import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';

export default () => {
  const { gql } = useAppContext();

  // eslint-disable-next-line import/prefer-default-export
  const PageInfoFragment = gql`
fragment PageInfoFragment on PaginationInfo {
  startCursor
  endCursor
  hasNextPage
  hasPreviousPage
}
`;

  return {
    PageInfoFragment,
  };
};
